<template>
  <section class="w-full h-full">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 136.35 136.35"
      class="svg-icon"
    >
      <path
        d="M75,13.83A61.17,61.17,0,1,1,13.83,75,61.24,61.24,0,0,1,75,13.83m0-7A68.17,68.17,0,1,0,143.17,75,68.17,68.17,0,0,0,75,6.83Z"
        transform="translate(-6.83 -6.83)"
      />
      <polygon
        class="cls-1"
        points="48.04 71.71 63.06 87.44 97.22 54.98 80.78 37.69 48.04 71.71"
      />
      <path
        class="cls-2"
        d="M98.21,42.58h.24l9,9.27a7.72,7.72,0,0,1-.76,3.14A13.61,13.61,0,0,1,104,59.22L69.42,92.76c-.3.22-2.23,1.45-10.86,4.34-3.47,1.17-7.14,2.31-10.35,3.28,1.06-3.18,2.31-6.81,3.58-10.25,3.15-8.55,4.43-10.44,4.65-10.73L91,45.85c1.73-1.68,5.24-3.27,7.22-3.27Zm0-4.3c-3.31,0-7.83,2.16-10.22,4.48L53.38,76.37C50.79,78.89,45,96.19,42.65,103.52a1.82,1.82,0,0,0,.41,1.86,1.85,1.85,0,0,0,1.3.55,1.76,1.76,0,0,0,.55-.09c7.39-2.14,24.85-7.41,27.45-9.92L107,62.31h0c3.3-3.21,6.43-10.5,3.81-13.2l-9.49-9.77a4.13,4.13,0,0,0-3.08-1.06Z"
        transform="translate(-6.83 -6.83)"
      />
      <polygon
        class="cls-2"
        points="41.09 88.29 46.76 93.68 38.69 96.23 41.09 88.29"
      />
    </svg>
    <IconNotification v-if="showNotification" class="edit-notification-icon" />
  </section>
</template>

<script>
import IconNotification from "@/components/icons/IconNotification";

export default {
  name: "IconRoundEdit",
  components: {
    IconNotification
  },
  props: {
    showNotification: {
      type: Boolean
    }
  }
};
</script>
<style scoped>
.edit-notification-icon {
  top: -33%;
  left: -33%;
  transform: scale(0.8);
}
</style>
